define('modules/cart-actions',['jquery', 'modules/overlay-box'], function ($, OverlayBox) {
  return (function () {
    var _this;

    function CartActions() {
      _this = this;
    }

    CartActions.prototype.openTemplate = function (templateName) {
      _this.ob = new OverlayBox($(templateName), {});
      _this.ob.setup();
      _this.ob.load(function () {
        _this.ob.show();
      });
    };

    CartActions.prototype.closeTemplate = function () {
      _this.ob.destroy();
    };

    CartActions.prototype.closeTemplateAndResetSelect = function () {
      if ($('#action').length) {
        $('#action').val('');
      }
      _this.closeTemplate();
    };

    CartActions.prototype.convertToOffer = function (e) {
      if (e) e.preventDefault();
      _this.openTemplate('#converToOfferPopup');
    };

    CartActions.prototype.saveAsDraft = function (e) {
      if (e) e.preventDefault();
      _this.openTemplate('#saveAsDraftPopup');
    };

    return CartActions;
  })(this);
});

